import {
  BabaBundle,
  Bagelcode2Bundle,
  BagelcodeBundle,
  BanditosBundle,
  BingoPopBundle,
  Candivore2Bundle,
  CandivoreBundle,
  CandyCrushBundle,
  CashFrenzyBundle,
  CashmanCasinoBundle,
  Communix2Bundle,
  CommunixBundle,
  DecaBundle,
  DefaultStudioLinearBundle,
  DefaultStudioThreeInOneBundle,
  DefaultStudioTwoInOneBundle,
  DrimageBundle,
  DynamicCashManCasinoBundle,
  DynamicHeartOfVegasBundle,
  DynamicLightningLinkBundle,
  DynamicMightyFuCasinoBundle,
  EvergreenDynamicBundle,
  FabelTownBundle,
  GhostBundle,
  HeartOfVegasBundle,
  JackpotSlotsBundle,
  JunesJourneyBundle,
  LightningLinkBundle,
  LoadCompleteBundle,
  LocoBingoBundle,
  MainSubBundle,
  MightyFuBundle,
  PipaBundle,
  PlaydogBundle,
  RoyalMatchBundle,
  SpinXBundle
} from '@appcharge/shared-ui';
import { EBundlesInternalViewModel } from 'constants/enums';

import { ETemplateStudioBundlesViewModel, EThemes } from '../enums';

import { BundleDesignsMetadata } from './types';

const defaultLinear: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.STUDIO_DEFAULT_LINEAR,
  version: '1.0.0',
  name: 'Default Linear',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: false,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/bundles/bundle_default_linear_subs.png',
    'https://media.appcharge.com/defaults/template-studio/bundles/bundle_default_linear_main.png',
    'https://media.appcharge.com/defaults/template-studio/bundles/bundle_default_linear_main_sub.png'
  ],
  bundleViewModel: ETemplateStudioBundlesViewModel.LINEAR,
  theme: EThemes.ROYAL_BLAST,
  maxSupportedProducts: 8,
  component: DefaultStudioLinearBundle
};

const defaultTwoInOne: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.STUDIO_DEFAULT_TWO_IN_ONE,
  version: '1.0.0',
  name: 'Default Two In One',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: false,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/bundles/bundle_default_two_in_one_subs.png',
    'https://media.appcharge.com/defaults/template-studio/bundles/bundle_default_two_in_one_main.png'
  ],
  bundleViewModel: ETemplateStudioBundlesViewModel.TWO_IN_ONE,
  theme: EThemes.ROYAL_BLAST,
  maxSupportedProducts: 3,
  component: DefaultStudioTwoInOneBundle
};

const defaultThreeInOne: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.STUDIO_DEFAULT_THREE_IN_ONE,
  version: '1.0.0',
  name: 'Default Three In One',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: false,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/bundles/bundle_default_three_in_one.png'
  ],
  bundleViewModel: ETemplateStudioBundlesViewModel.THREE_IN_ONE,
  theme: EThemes.ROYAL_BLAST,
  maxSupportedProducts: 1,
  component: DefaultStudioThreeInOneBundle
};

const defaultHuuuge: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.MAIN_SUB,
  version: '1.0.0',
  name: 'Huuuge',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/bundles/bundle_huge.png'
  ],
  bundleViewModel: ETemplateStudioBundlesViewModel.LINEAR,
  theme: EThemes.HUUUGE,
  maxSupportedProducts: 20,
  component: MainSubBundle
};

const defaultCashmanCasino: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.CASHMAN_CASINO,
  version: '1.0.0',
  name: 'Cashman Casino',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/bundles/bundle_cmc.png'
  ],
  bundleViewModel: ETemplateStudioBundlesViewModel.TWO_IN_ONE,
  theme: EThemes.CASHMAN_CASINO,
  maxSupportedProducts: 2,
  component: CashmanCasinoBundle
};

const dynamicCashmanCasino: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.DYNAMIC_CASH_MAN_CASINO,
  version: '1.0.0',
  name: 'Cashman Casino Dynamic',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/bundles/bundle_cmc.png'
  ],
  bundleViewModel: ETemplateStudioBundlesViewModel.TWO_IN_ONE_DYNAMIC,
  theme: EThemes.CASHMAN_CASINO,
  maxSupportedProducts: 20,
  component: DynamicCashManCasinoBundle
};

const dynamicEvergreen: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.EVERGREEN_DYNAMIC,
  version: '1.0.0',
  name: 'Evergreen Dynamic',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [],
  bundleViewModel: ETemplateStudioBundlesViewModel.TWO_IN_ONE_DYNAMIC,
  theme: EThemes.EVERGREEN,
  maxSupportedProducts: 2,
  component: EvergreenDynamicBundle
};

const defaultProductMadnessJackpotSlots: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.JACKPOT_SLOTS,
  version: '1.0.0',
  name: 'Jackpot Slots',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/bundles/bundle_jmc.png'
  ],
  bundleViewModel: ETemplateStudioBundlesViewModel.LINEAR,
  theme: EThemes.PM_Franchise,
  maxSupportedProducts: 20,
  component: JackpotSlotsBundle
};

const defaultProductMadnessBigFishCasino: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.BIG_FISH_CASINO,
  version: '1.0.0',
  name: 'Big Fish Casino',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/bundles/bundle_bfc.png'
  ],
  bundleViewModel: ETemplateStudioBundlesViewModel.LINEAR,
  theme: EThemes.PM_Franchise,
  maxSupportedProducts: 20,
  component: JackpotSlotsBundle
};

const defaultLightningLink: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.LIGHTNING_LINK_CASINO,
  version: '1.0.0',
  name: 'Lightning Link',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/bundles/bundle_llc.png'
  ],
  bundleViewModel: ETemplateStudioBundlesViewModel.TWO_IN_ONE,
  theme: EThemes.LIGHTNING_LINK_CASINO,
  maxSupportedProducts: 2,
  component: LightningLinkBundle
};

const dynamicLightningLink: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.LIGHTNING_LINK_CASINO2,
  version: '1.0.0',
  name: 'Lightning Link Dynamic',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/bundles/bundle_llc.png'
  ],
  bundleViewModel: ETemplateStudioBundlesViewModel.TWO_IN_ONE_DYNAMIC,
  theme: EThemes.LIGHTNING_LINK_CASINO,
  maxSupportedProducts: 2,
  component: DynamicLightningLinkBundle
};

const defaultHeartOfVegas: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.HEART_OF_VEGAS,
  version: '1.0.0',
  name: 'Heart Of Vegas',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/bundles/bundle_hov.png'
  ],
  bundleViewModel: ETemplateStudioBundlesViewModel.TWO_IN_ONE,
  theme: EThemes.HEART_OF_VEGAS,
  maxSupportedProducts: 2,
  component: HeartOfVegasBundle
};

const dynamicHeartOfVegas: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.DYNAMIC_HEART_OF_VEGAS,
  version: '1.0.0',
  name: 'Heart Of Vegas Dynamic',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/bundles/bundle_hov.png'
  ],
  bundleViewModel: ETemplateStudioBundlesViewModel.TWO_IN_ONE_DYNAMIC,
  theme: EThemes.HEART_OF_VEGAS,
  maxSupportedProducts: 2,
  component: DynamicHeartOfVegasBundle
};

const defaultMightyFuCasino: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.MIGHTY_FU_CASINO,
  version: '1.0.0',
  name: 'Mighty Fu Casino',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/bundles/bundle_mfc.png'
  ],
  bundleViewModel: ETemplateStudioBundlesViewModel.TWO_IN_ONE,
  theme: EThemes.MIGHTY_FU_CASINO,
  maxSupportedProducts: 2,
  component: MightyFuBundle
};

const defaultFabelTown: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.FABEL_TOWN,
  version: '1.0.0',
  name: 'Fabel Town',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/bundles/bundle_fable_town.png'
  ],
  bundleViewModel: ETemplateStudioBundlesViewModel.THREE_IN_ONE,
  theme: EThemes.FABEL_TOWN,
  maxSupportedProducts: 2,
  component: FabelTownBundle
};

const dynamicMightyFuCasino: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.DYNAMIC_MIGHTY_FU_CASINO,
  version: '1.0.0',
  name: 'Mighty Fu Casino Dynamic',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/bundles/bundle_mfc.png'
  ],
  bundleViewModel: ETemplateStudioBundlesViewModel.TWO_IN_ONE_DYNAMIC,
  theme: EThemes.MIGHTY_FU_CASINO,
  maxSupportedProducts: 2,
  component: DynamicMightyFuCasinoBundle
};

const defaultCandivore: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.MATCH,
  version: '1.0.0',
  name: 'Candivore',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [],
  bundleViewModel: ETemplateStudioBundlesViewModel.LINEAR,
  theme: EThemes.CANDIVORE,
  maxSupportedProducts: 1,
  component: CandivoreBundle
};

const defaultCandivore2: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.CANDIVORE,
  version: '1.0.0',
  name: 'Candivore2',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [],
  bundleViewModel: ETemplateStudioBundlesViewModel.LINEAR,
  theme: EThemes.CANDIVORE,
  maxSupportedProducts: 1,
  component: Candivore2Bundle
};

const defaultBaba: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.BABA,
  version: '1.0.0',
  name: 'Baba',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/bundles/bundle_baba.png'
  ],
  bundleViewModel: ETemplateStudioBundlesViewModel.LINEAR,
  theme: EThemes.BABA,
  maxSupportedProducts: 9,
  component: BabaBundle
};

// const defaultBabaNew: BundleDesignsMetadata = {
//   id: EBundlesInternalViewModel.BABAD_NEW,
//   version: '2.0.0',
//   name: 'New Baba',
//   createdAt: '2025-08-28T08:37:11.255Z',
//   isPrivate: true,
//   previewAssets: [],
//   bundleViewModel: ETemplateStudioBundlesViewModel.LINEAR,
//   theme: EThemes.BABA,
//   maxSupportedProducts: 9,
//   component: BabaBundle
// };

// Definition of "Not updated" Template:
// currently used bundle in activated project, has same theme as another bundle that its created date is newer!!! AND < month
// when we enter template studio feature, we should run over the bundles/promotions/RO, and check if selected theme of each has newer version that is less than month old AND is not selected.
// We mark this active template as "Not updated"

const defaultBagelcode2: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.BAGELCODE2,
  version: '1.0.0',
  name: 'Bagelcode',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/bundles/bundle_club_vegas.png'
  ],
  bundleViewModel: ETemplateStudioBundlesViewModel.THREE_IN_ONE,
  theme: EThemes.BAGELCODE,
  maxSupportedProducts: 1,
  component: Bagelcode2Bundle
};

const defaultCommunix: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.COMMUNIX,
  version: '1.0.0',
  name: 'Communix',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/bundles/bundle_pokerface.png'
  ],
  bundleViewModel: ETemplateStudioBundlesViewModel.THREE_IN_ONE,
  theme: EThemes.COMMUNIX,
  maxSupportedProducts: 1,
  component: CommunixBundle
};

const defaultCommunix2: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.COMMUNIX2,
  version: '1.0.0',
  name: 'Communix',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/bundles/bundle_pokerface.png'
  ],
  bundleViewModel: ETemplateStudioBundlesViewModel.THREE_IN_ONE,
  theme: EThemes.COMMUNIX,
  maxSupportedProducts: 1,
  component: Communix2Bundle
};

const defaultBingoPop: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.BINGO_POP,
  version: '1.0.0',
  name: 'Bingo Pop',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/bundles/bundle_bingo_pop.png'
  ],
  bundleViewModel: ETemplateStudioBundlesViewModel.LINEAR,
  theme: EThemes.BINGO_POP,
  maxSupportedProducts: 6,
  component: BingoPopBundle
};

const defaultLocoBingo: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.LOCO_BINGO,
  version: '1.0.0',
  name: 'Loco Bingo',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/bundles/bundle_locobingo.png'
  ],
  bundleViewModel: ETemplateStudioBundlesViewModel.LINEAR,
  theme: EThemes.LOCO_BINGO,
  maxSupportedProducts: 1,
  component: LocoBingoBundle
};

const defaultGhost: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.GHOST,
  version: '1.0.0',
  name: 'Ghost',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/bundles/bundle_ghost.png'
  ],
  bundleViewModel: ETemplateStudioBundlesViewModel.LINEAR,
  theme: EThemes.GHOST,
  maxSupportedProducts: 5,
  component: GhostBundle
};

const defaultJunesJourney: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.JUNES_JOURNEY,
  version: '1.0.0',
  name: 'Junes Journey',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/bundles/bundle_wooga.png'
  ],
  bundleViewModel: ETemplateStudioBundlesViewModel.TWO_IN_ONE_DYNAMIC,
  theme: EThemes.JUNES_JOURNEY,
  maxSupportedProducts: 3,
  component: JunesJourneyBundle
};

const defaultCandyCrush: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.CANDY_CRUSH,
  version: '1.0.0',
  name: 'Candy Crush',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/bundles/bundle_wooga.png'
  ],
  bundleViewModel: ETemplateStudioBundlesViewModel.TWO_IN_ONE_DYNAMIC,
  theme: EThemes.KING,
  maxSupportedProducts: 4,
  component: CandyCrushBundle
};

const defaultDeca: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.DECA,
  version: '1.0.0',
  name: 'Deca',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [],
  bundleViewModel: ETemplateStudioBundlesViewModel.TWO_IN_ONE_DYNAMIC,
  theme: EThemes.DECA,
  maxSupportedProducts: 20,
  component: DecaBundle
};

const defaultPipa: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.PIPA,
  version: '1.0.0',
  name: 'Pipa',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [],
  bundleViewModel: ETemplateStudioBundlesViewModel.THREE_IN_ONE,
  theme: EThemes.PIPA,
  maxSupportedProducts: 3,
  component: PipaBundle
};

const defaultPlaydog: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.PLAYDOG,
  version: '1.0.0',
  name: 'Playdog',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [],
  bundleViewModel: ETemplateStudioBundlesViewModel.TWO_IN_ONE_DYNAMIC,
  theme: EThemes.PLAYDOG,
  maxSupportedProducts: 7,
  component: PlaydogBundle
};

const defaultSpinX: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.SPIN_X,
  version: '1.0.0',
  name: 'Spin X',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [],
  bundleViewModel: ETemplateStudioBundlesViewModel.LINEAR,
  theme: EThemes.SPIN_X,
  maxSupportedProducts: 5,
  component: SpinXBundle
};

const defaultCashFrenzy: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.CASH_FRENZY,
  version: '1.0.0',
  name: 'Cash Frenzy',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [],
  bundleViewModel: ETemplateStudioBundlesViewModel.LINEAR,
  theme: EThemes.CASH_FRENZY,
  maxSupportedProducts: 5,
  component: CashFrenzyBundle
};

const defaultLoadComplete: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.LOAD_COMPLETE,
  version: '1.0.0',
  name: 'Load Complete',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/bundles/bundle_loadcomplete.png'
  ],
  bundleViewModel: ETemplateStudioBundlesViewModel.THREE_IN_ONE,
  theme: EThemes.LOAD_COMPLETE,
  maxSupportedProducts: 10,
  component: LoadCompleteBundle
};

const defaultBanditos: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.BANDITOS,
  version: '1.0.0',
  name: 'Banditos',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/bundles/bundle_banditos.png'
  ],
  bundleViewModel: ETemplateStudioBundlesViewModel.LINEAR,
  theme: EThemes.BANDITOS,
  maxSupportedProducts: 8,
  component: BanditosBundle
};

const defaultDrimage: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.DRIMAGE,
  version: '1.0.0',
  name: 'Drimage',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/bundles/bundle_drimage.png'
  ],
  bundleViewModel: ETemplateStudioBundlesViewModel.LINEAR,
  theme: EThemes.DRIMAGE,
  maxSupportedProducts: 20,
  component: DrimageBundle
};

const defaultRoyalMatch: BundleDesignsMetadata = {
  id: EBundlesInternalViewModel.ROYAL_MATCH,
  version: '1.0.0',
  name: 'Dream Royal Match',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [],
  bundleViewModel: ETemplateStudioBundlesViewModel.THREE_IN_ONE,
  theme: EThemes.ROYAL_MATCH,
  maxSupportedProducts: 1,
  component: RoyalMatchBundle
};

export const bundleDesigns = {
  defaultHuuuge,
  defaultLightningLink,
  dynamicLightningLink,
  defaultCashmanCasino,
  dynamicCashmanCasino,
  dynamicEvergreen,
  defaultProductMadnessJackpotSlots,
  defaultProductMadnessBigFishCasino,
  defaultHeartOfVegas,
  dynamicHeartOfVegas,
  defaultMightyFuCasino,
  dynamicMightyFuCasino,
  defaultFabelTown,
  defaultLoadComplete,
  defaultCandivore,
  defaultCandivore2,
  defaultBaba,
  defaultBagelcode2,
  defaultCommunix,
  defaultCommunix2,
  defaultBingoPop,
  defaultLocoBingo,
  defaultGhost,
  defaultJunesJourney,
  defaultDeca,
  defaultPipa,
  defaultPlaydog,
  defaultSpinX,
  defaultCashFrenzy,
  defaultBanditos,
  defaultDrimage,
  defaultLinear,
  defaultTwoInOne,
  defaultThreeInOne,
  defaultRoyalMatch,
  defaultCandyCrush
};

export const bundleDesignsByTheme: Record<EThemes, BundleDesignsMetadata[]> =
  Object.values(bundleDesigns).reduce(
    (acc, design) => {
      if (!acc[design.theme]) {
        acc[design.theme] = [];
      }
      acc[design.theme].push(design);
      return acc;
    },
    {} as Record<EThemes, BundleDesignsMetadata[]>
  );

export const bundleDesignsById: Record<string, BundleDesignsMetadata> =
  Object.values(bundleDesigns).reduce(
    (acc, design) => {
      acc[design.id as string] = design;
      return acc;
    },
    {} as Record<string, BundleDesignsMetadata>
  );
